import { TIMELINE_WINDOW_HOURS } from '../lib/timeline';

interface TimelineGridLinesProps {
  hourWidthPx: number;
  timelineWidthPx: number;
}

export function TimelineGridLines({
  hourWidthPx,
  timelineWidthPx,
}: TimelineGridLinesProps) {
  const hours = Array.from(
    { length: TIMELINE_WINDOW_HOURS },
    (_, index) => index,
  );
  const halfHourOffsetPx = hourWidthPx / 2;

  return (
    <div
      className='pointer-events-none absolute inset-0'
      style={{ width: timelineWidthPx }}
    >
      {hours.map((index) => (
        <div
          key={`hour-${index}`}
          className='absolute inset-y-0 border-r-2 border-border/50'
          style={{ left: index * hourWidthPx, width: hourWidthPx }}
        />
      ))}
      {hours.map((index) => (
        <div
          key={`half-${index}`}
          className='absolute inset-y-0 w-0 border-r-2 border-dotted border-border/40'
          style={{ left: index * hourWidthPx + halfHourOffsetPx }}
        />
      ))}
    </div>
  );
}
